module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/cosa-facciamo/cosa-facciamo.component.scss
// module id = ./src/app/cosa-facciamo/cosa-facciamo.component.scss
// module chunks = main